import { AxiosResponse } from "axios";
import { axiosInstanceV1 } from "./axiosInstance";

/*
	Aula virtual (Fase 2, 2026-10-16), lado del personal: el maestro abre su aula (/admin/aula/_open) y
	Caja / Servicios Académicos / Dirección dan el pase de 48 h (/admin/aula/_passes). El servidor decide
	quién puede: aquí no se manda ni rol ni nombre.
*/
export interface PaseDeAula
{
	id: number
	reason: string
	by: string | null
	untilMs: number
	untilLabel: string
	givenLabel: string
	active: boolean
}

export interface EstadoDePases
{
	student: { id: number; name: string | null }
	canGive: boolean
	hours: number
	hasOverdue: boolean
	overdue: { currency: string; symbol: string; amount: number }[]
	oldestOverdue: { title: string; dueDate: string; dueLabel: string } | null
	pass: PaseDeAula | null
	history: PaseDeAula[]
}

export class AulaService
{
	openRoom = async (scheduleId: number): Promise<AxiosResponse<{ url: string }>> =>
		axiosInstanceV1.post<{ url: string }>("/admin/aula/_open/" + scheduleId)
	//Celular del maestro como segunda cámara: enlace de un solo uso (10 min) para el código QR.
	cameraToken = async (scheduleId: number): Promise<AxiosResponse<{ url: string; expiresAtMs: number; minutes: number }>> =>
		axiosInstanceV1.post<{ url: string; expiresAtMs: number; minutes: number }>("/admin/aula/_camera/" + scheduleId)
	passState = async (studentId: number): Promise<AxiosResponse<EstadoDePases>> =>
		axiosInstanceV1.get<EstadoDePases>("/admin/aula/_passes/" + studentId)
	givePass = async (studentId: number, reason: string): Promise<AxiosResponse<EstadoDePases>> =>
		axiosInstanceV1.post<EstadoDePases>("/admin/aula/_passes/" + studentId, { reason })
}

const aulaService = new AulaService()
export default aulaService
